import "./productList.css";
import { DataGrid } from "@material-ui/data-grid";
import { DeleteOutline } from "@material-ui/icons";
import { Link } from "react-router-dom";
import {useProductsContext} from "../../hooks/useProductsContext"


export default function ProductList() {
 
const {products,dispatch} = useProductsContext()
 

  const handleDelete = async (_id) => {
   
    const response = await fetch(`http://localhost:4000/api/products/${_id}` ,{
      method:'DELETE',
    
    })
    const json = await response.json()
    if(response.ok) {
      dispatch({type:'DELETE_PRODUCT',payload:json})
    }
  }

  const columns = [
  
    {
      field: "product",
      headerName: "Product",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="productListItem">
            <img className="productListImg" src={params.row.url} alt="" />
            {params.row.name}
          </div>
        );
      },
    },
    { field: "color", headerName: "Color", width: 150 },
    { field: "size", headerName: "Size", width: 150 },
    { field: "category", headerName: "Category", width: 150 },

    
    { field: "stock", headerName: "Stock", width: 150 },
   
    {
      field: "price",
      headerName: "Price",
      width: 160,
    },
  
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
       
        return (
          <div className="container">
            <Link to={"/product/" + params.row._id}>
              <button className="productListEdit">Edit</button>
            </Link>
            <DeleteOutline
              className="productListDelete"
              onClick={() => handleDelete(params.row._id)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
    {products && 
     <div className="productList">
      <DataGrid
        rows={products}
        disableSelectionOnClick
        columns={columns}
        pageSize={12}
        checkboxSelection
      />
    </div>}
    </>
  );
}
